import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import './css/CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const acceptAllCookies = () => {
    localStorage.setItem('cookieConsent', 'all');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  const acceptNecessaryOnly = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  const handleDetailsClick = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-overlay">
      <div className="cookie-container">
        <div className="cookie-content">
          {/* Декоративные элементы */}
          <div className="cookie-decoration cookie-decoration-1"></div>
          <div className="cookie-decoration cookie-decoration-2"></div>
          
          {/* Основной контент */}
          <div className="cookie-main">
            <div className="cookie-text-section">
              <div className="cookie-description">
                <p>
                  Мы используем cookie-файлы, чтобы улучшить работу сайта 
                </p>
              </div>
            </div>

            <div className="cookie-actions-section">
              <div className="cookie-actions">
                <button 
                  className="cookie-btn cookie-btn-primary"
                  onClick={acceptAllCookies}
                >
                  Принять
                </button>
                <Link 
                  to="/privacy-policy"
                  className="cookie-btn cookie-btn-secondary"
                  onClick={handleDetailsClick}
                >
                  Подробнее
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;